export default function hexCode(value)
{
	return '%'+value.charCodeAt(0).toString(16);
}